<template>
  <HrmisCrudModule v-bind="config" />
</template>

<script>
import HrmisCrudModule from "./HrmisCrudModule.vue";

export default {
  name: "ModuleActingAppointment",
  components: { HrmisCrudModule },
  data() {
    return {
      config: {
        title: "Acting appointments",
        subtitle: "Temporary acting roles and coverage",
        icon: "👤",
        listFunction: "getActingAppointmentList",
        saveFunction: "saveActingAppointment",
        permissionViewCodes: ["ACTING_APPOINTMENT_VIEW", "ACTING_APPOINTMENT_MANAGE"],
        permissionManageCodes: ["ACTING_APPOINTMENT_MANAGE"],
        loadEmployees: true,
        columns: [
          { key: "employee_name", label: "Employee" },
          { key: "acting_position", label: "Acting as" },
          { key: "from_date", label: "From" },
          { key: "to_date", label: "To" },
          { key: "status", label: "Status" }
        ],
        fields: [
          { key: "employee_id", label: "Employee", type: "employee", required: true, lockOnEdit: true },
          { key: "acting_position", label: "Acting position", type: "text" },
          { key: "principal_name", label: "Principal / incumbent", type: "text" },
          { key: "from_date", label: "From", type: "date" },
          { key: "to_date", label: "To", type: "date" },
          { key: "reason", label: "Reason", type: "textarea" },
          {
            key: "status",
            label: "Status",
            type: "select",
            options: ["Active", "Ended"],
            default: "Active"
          }
        ]
      }
    };
  }
};
</script>
